import { ExclusiveGroup, KFMemberTier, PRIVILEGE_TAG_ATTRIBUTES, WaysToRedeem } from '@constants/privilege.constants.tsx';
import { IPrivilege } from '@interfaces/privilege';

export const setPrivTags = (priv: IPrivilege) => {
	if (priv.exclusiveGroup !== ExclusiveGroup.ALL) {
		switch (priv.exclusiveGroup) {
			case ExclusiveGroup.BIRTHDAY:
				priv.tagAttribute = PRIVILEGE_TAG_ATTRIBUTES.BIRTHDAY;
				break;
			case ExclusiveGroup.TOURIST:
				priv.tagAttribute = PRIVILEGE_TAG_ATTRIBUTES.TOURIST;
				break;
			case ExclusiveGroup.KF_MEMBERSHIP:
				if (priv?.exclusiveKfMebership === KFMemberTier.SILVER || priv?.exclusiveKfMebership === KFMemberTier.GOLD) {
					priv.tagAttribute = PRIVILEGE_TAG_ATTRIBUTES.ELITE_MEMBER;
				} else {
					priv.tagAttribute = PRIVILEGE_TAG_ATTRIBUTES.PPS_CLUB;
				}
				break;
			default:
				priv.tagAttribute = PRIVILEGE_TAG_ATTRIBUTES.IN_STORE;
				break;
		}
	} else {
		if (priv.wayToRedeem === WaysToRedeem.EXCLUSIVE_URL || priv.wayToRedeem === WaysToRedeem.PROMO_CODE) {
			priv.tagAttribute = PRIVILEGE_TAG_ATTRIBUTES.ONLINE;
		} else {
			priv.tagAttribute = PRIVILEGE_TAG_ATTRIBUTES.IN_STORE;
		}
	}
	return priv;
};
